exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-collapse {\n  display: flex;\n  align-items: baseline;\n  margin: 0.5rem 0 0.5rem 0;\n}\n.navbar-collapse .btn {\n  padding: 0.35rem 0.65rem;\n}\n.navbar-collapse #signUpButton {\n  margin-right: 5px;\n}\n", ""]);

// exports
